(() => {
  if (customElements.get('ls-announcement-rotator')) return;

  class LSAnnouncementRotator extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;

      this.dataset.ready = 'true';
      this.slides = Array.from(this.querySelectorAll('[data-ls-announcement-slide]'));
      this.index = Math.max(
        0,
        this.slides.findIndex((slide) => slide.classList.contains('is-active')),
      );
      this.interval = Math.max(5000, Number(this.dataset.interval) || 10000);
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.timer = null;

      this.slides.forEach((slide, index) => this.setSlideState(slide, index === this.index));

      if (this.slides.length < 2 || this.motionQuery.matches) return;

      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.stop();
        else this.start();
      });
      this.motionQuery.addEventListener('change', () => {
        if (this.motionQuery.matches) this.stop();
        else this.start();
      });

      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    setSlideState(slide, active) {
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      slide.querySelectorAll('a, button').forEach((control) => {
        control.tabIndex = active ? 0 : -1;
      });
    }

    showNext() {
      const previous = this.slides[this.index];
      const nextIndex = (this.index + 1) % this.slides.length;
      const next = this.slides[nextIndex];

      previous.classList.remove('is-active');
      previous.classList.add('is-leaving');
      previous.setAttribute('aria-hidden', 'true');
      previous.querySelectorAll('a, button').forEach((control) => {
        control.tabIndex = -1;
      });

      this.setSlideState(next, true);
      window.setTimeout(() => previous.classList.remove('is-leaving'), 700);
      this.index = nextIndex;
    }

    start() {
      if (this.timer || this.slides.length < 2 || this.motionQuery.matches || document.hidden) return;
      this.timer = window.setInterval(() => this.showNext(), this.interval);
    }

    stop() {
      if (!this.timer) return;
      window.clearInterval(this.timer);
      this.timer = null;
    }
  }

  customElements.define('ls-announcement-rotator', LSAnnouncementRotator);
})();
